import { createSingleAction } from 'store/utils';

const SET_REDIRECT_TO_JOB_NUMBER_WITH_DEAL_NUMBER = 'settings/SET_REDIRECT_TO_JOB_NUMBER_WITH_DEAL_NUMBER';
export const setRedirectToJobNumberWithDealNumber = createSingleAction<string | null,
    typeof SET_REDIRECT_TO_JOB_NUMBER_WITH_DEAL_NUMBER>(
    SET_REDIRECT_TO_JOB_NUMBER_WITH_DEAL_NUMBER,
);
